<template>
  <manage-ticket
    :application="deTicketApplications.MIPE"
    :modules="modulesAndScreens"
    :on-download="onDownloadHandler"
    :read-only="readOnly"
    :reference-number-types="referenceNumberTypes"
    :save-ticket="saveUserCase"
    :ticket-data="ticketData"
    :user="userProfile"
    :validate-reference-number="validateReferenceNumber"
    @update-references="fetchReferenceNumberTypes"
  />
</template>

<script>
import ManageTicket from '@/views/helpdesk/ManageTicket.vue';
import {
  getUserCaseById,
  getUserCaseReferenceNumberTypes,
  saveUserCase as _saveUserCase,
  downloadDocument,
  getPreviousContactInformation,
  validateReferenceNumber as _validateReferenceNumber,
  getModulesWithScreens as _getModulesWithScreens,
} from '@/services/common/helpdesk.api.js';
import { downloadDocumentByAttachment as _downloadDocumentByAttachment } from '@/services/common/document.api.js';
import deTicketApplications from '@/utils/constants/deTicketApplications.js';
import objectToFormData from 'object-to-formdata';

const initialModel = () => ({
  itemId: null,
  description: null,
  documents: [
    {
      tempId: 1,
      id: null,
      data: null,
      name: null,
    },
  ],
  module: null,
  screen: null,
  referenceNumberTypes: [],
  email: null,
  telephone1: null,
  telephone2: null,
  statusId: null,
  workflowId: null,
  userContactInformation: {},
});

export default {
  name: 'CreateTicket',
  components: { ManageTicket },
  data() {
    return {
      deTicketApplications,
      ticketData: initialModel(),
      readOnly: false,
      referenceNumberTypes: [],
      previousUserContactInfo: {},
      modulesAndScreens: [],
    };
  },

  async mounted() {
    const { id } = this.$route.params;
    await this.fetchReferenceNumberTypes();
    const contactInfo = await this.getPreviousContactInfo();
    if (id) {
      const { data } = await getUserCaseById(id);
      this.ticketData = {
        ...data,
        module: data.module,
        screen: data.screen,
        documents: data.documents ?? [],
      };
      this.readOnly = true;
    } else {
      this.ticketData.userContactInformation = contactInfo;
    }
    this.modulesAndScreens = await this.getModules();
  },
  methods: {
    validateReferenceNumber(reference, referenceType) {
      return _validateReferenceNumber(reference, referenceType);
    },
    async fetchReferenceNumberTypes(params) {
      const { data } = await getUserCaseReferenceNumberTypes(params);
      this.referenceNumberTypes = [...data];
    },
    saveUserCase(data) {
      const formData = objectToFormData(data, {
        indices: true,
        nullsAsUndefineds: true,
      });
      (data.files || [])
        .filter((x) => x?.name)
        .forEach((file) => {
          formData.append('files', file);
        });
      return _saveUserCase(formData);
    },
    onDownloadHandler(fileId) {
      if (fileId) {
        downloadDocument(fileId);
      } else {
        let file = {
          filename: document.filename,
          content: document.file,
          contentType: 'application/pdf',
        };
        _downloadDocumentByAttachment(file);
      }
    },
    async getPreviousContactInfo() {
      const { data } = await getPreviousContactInformation();
      return data;
    },
    async getModules() {
      const { data } = await _getModulesWithScreens();
      return data;
    },
  },
};
</script>
